/* Cocina con Lola · página «pro»: galería, opciones de compra, regalo con fecha real, barra fija, vídeos y compra directa al checkout. */
(() => {
  const root = document.querySelector('[data-lp-buy]');
  if (!root) return;
  const locale = root.dataset.locale || 'es-ES';
  const currency = root.dataset.currency || 'EUR';
  const money = (cents) => {
    try {
      const s = (cents / 100).toLocaleString(locale, { style: 'currency', currency });
      // Pesos: «$ 379.00», con espacio, igual que el formato de Shopify (Liquid) del resto de la página.
      return currency === 'MXN' ? s.replace(/^\$/, () => '$\u00a0') : s;
    }
    catch (e) { return `${(cents / 100).toFixed(2).replace('.', ',')} €`; }
  };

  // Galería: deslizar en el móvil (puntos) y miniaturas en el ordenador.
  document.querySelectorAll('[data-lp-gal]').forEach((gal) => {
    const track = gal.querySelector('[data-lp-track]');
    const slides = [...gal.querySelectorAll('.lp-gal__slide')];
    const dots = [...gal.querySelectorAll('.lp-gal__dots span')];
    const thumbs = [...gal.querySelectorAll('[data-lp-thumb]')];
    const mark = (i) => {
      dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
      thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) mark(slides.indexOf(e.target)); });
      }, { root: track, threshold: 0.6 });
      slides.forEach((s) => io.observe(s));
    }
    thumbs.forEach((t, i) => t.addEventListener('click', () => {
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      mark(i);
    }));
  });

  // Opciones de compra: el botón, la barra fija y el cierre muestran el precio de la opción elegida
  // (más las colecciones sueltas que la clienta marque, si la página las ofrece).
  const tiers = [...root.querySelectorAll('input[name="lp-tier"]')];
  const current = () => tiers.find((t) => t.checked) || tiers[0];
  // Colecciones sueltas: casillas SIN marcar de serie. Con la opción del pack, las que ya van en el pack se desmarcan y se
  // ocultan (no se compran dos veces). El aviso del pack solo sale si de verdad es más barato y nunca cambia de opción solo.
  const extras = [...root.querySelectorAll('[data-lp-extra]')];
  const extrasBox = root.querySelector('[data-lp-extras]');
  const nudge = root.querySelector('[data-lp-nudge]');
  const hasPack = (t) => !!t && t.hasAttribute('data-has-pack');
  const inPack = (x) => !!x.closest('[data-in-pack]');
  const extrasFor = (t) => extras.filter((x) => x.checked && !x.disabled && !(hasPack(t) && inPack(x)));
  const sum = (list) => list.reduce((s, x) => s + Number(x.dataset.price), 0);
  const fill = (tpl, map) => Object.keys(map).reduce((s, k) => s.split(k).join(map[k]), tpl || '');
  const paint = () => {
    const t = current();
    if (!t) return;
    if (hasPack(t)) extras.forEach((x) => { if (inPack(x)) x.checked = false; });
    const chosen = extrasFor(t);
    document.querySelectorAll('[data-lp-total]').forEach((el) => { el.textContent = money(Number(t.dataset.price) + sum(chosen)); });
    document.querySelectorAll('[data-lp-cta-label]').forEach((el) => { el.textContent = t.dataset.cta; });
    if (!extras.length) return;
    let shown = 0;
    extras.forEach((x) => {
      const hide = hasPack(t) && inPack(x);
      x.closest('.lp-extra').hidden = hide;
      if (!hide) shown += 1;
    });
    if (extrasBox) extrasBox.hidden = shown === 0;
    if (nudge) {
      const mine = chosen.filter(inPack);
      const show = !hasPack(t) && mine.length > 0 && mine.length >= Number(nudge.dataset.min || 3) && sum(mine) > Number(nudge.dataset.packPrice);
      nudge.hidden = !show;
      const txt = nudge.querySelector('[data-lp-nudge-text]');
      if (show && txt) txt.textContent = fill(nudge.dataset.tpl, { '%K%': String(mine.length), '%SUM%': money(sum(mine)) });
    }
    // Cierre: cada botón enseña lo que compra de verdad (su opción + las colecciones marcadas que no estén ya en el pack).
    document.querySelectorAll('[data-lp-tier-price]').forEach((el) => {
      const tt = tiers.find((x) => x.value === el.dataset.lpTierPrice);
      if (tt) el.textContent = money(Number(tt.dataset.price) + sum(extrasFor(tt)));
    });
    document.querySelectorAll('[data-lp-extras-note]').forEach((el) => {
      el.hidden = chosen.length === 0;
      el.textContent = chosen.length ? fill(el.dataset.tpl, { '%NAMES%': chosen.map((x) => x.dataset.name).join(', '), '%SUM%': money(sum(chosen)) }) : '';
    });
  };
  tiers.forEach((t) => t.addEventListener('change', paint));
  extras.forEach((x) => x.addEventListener('change', paint));
  const toPack = root.querySelector('[data-lp-to-pack]');
  if (toPack) {
    toPack.addEventListener('click', () => {
      const pick = tiers.find(hasPack);
      if (!pick) return;
      pick.checked = true;
      paint();
      pick.focus();
    });
  }
  paint();

  const buy = (tierId) => {
    if (tierId) {
      const pick = tiers.find((t) => t.value === tierId);
      if (pick) { pick.checked = true; paint(); }
    }
    const t = current();
    const base = (t ? t.dataset.items : root.dataset.items).split(',').filter(Boolean);
    const ids = [...new Set([...base, ...extrasFor(t).map((x) => x.value)])];
    const items = ids.map((v) => `${v}:1`);
    const params = new URLSearchParams();
    if (root.dataset.abKey) params.set(`attributes[${root.dataset.abKey}]`, root.dataset.abValue || '');
    document.querySelectorAll('[data-lp-go]').forEach((b) => b.setAttribute('aria-busy', 'true'));
    // Sin fbq('track','InitiateCheckout') aquí: la app de Facebook ya lo envía desde el checkout (checkout_started, con
    // event_id para la API de conversiones). Lanzarlo también aquí lo contaba dos veces en Meta.
    window.location.href = `${root.dataset.cartUrl || '/cart'}/${items.join(',')}?${params.toString()}`;
  };
  root.addEventListener('submit', (e) => { e.preventDefault(); buy(); });
  document.querySelectorAll('[data-lp-go]').forEach((btn) => {
    if (btn.type === 'submit' && root.contains(btn)) return;
    btn.addEventListener('click', (e) => { e.preventDefault(); buy(btn.dataset.lpTier); });
  });
  // Al volver atrás desde el checkout, los botones dejan de estar «cargando» y los totales se recalculan.
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-lp-go]').forEach((b) => b.removeAttribute('aria-busy'));
    paint();
  });

  // Barra fija: sale cuando el botón principal ya ha quedado arriba y se esconde al llegar al pie de la tienda,
  // para no tapar sus enlaces (el último es «Desistir del contrato»).
  const sticky = document.querySelector('[data-lp-sticky]');
  const anchor = root.querySelector('button[type="submit"]');
  const footer = [...document.querySelectorAll('footer')].filter((f) => !f.closest('.lp')).pop();
  if (sticky && anchor) {
    let queued = false;
    const check = () => {
      queued = false;
      const past = anchor.getBoundingClientRect().bottom < 0;
      const atFooter = !!footer && footer.getBoundingClientRect().top < window.innerHeight;
      sticky.classList.toggle('is-visible', past && !atFooter);
    };
    const queue = () => { if (!queued) { queued = true; requestAnimationFrame(check); } };
    // En el ordenador, Horizon hace scroll dentro de .page-wrapper (no en la ventana): se escucha en fase de captura.
    document.addEventListener('scroll', queue, { passive: true, capture: true });
    window.addEventListener('resize', queue, { passive: true });
    check();
  }

  // Regalos con fecha real (Liquid ya los pinta según la hora; esto los cambia a su hora aunque la página venga de la caché
  // o lleve horas abierta).
  // - Oferta 1: hasta gift_end (data-gift-end del formulario). data-lp-gift-show sale solo mientras dura; data-lp-gift-hide, al revés.
  // - Oferta 2: data-lp-win="2", del inicio al fin de la oferta (data-lp-from / data-lp-to en el propio elemento o, si no
  //   los lleva, los de la cabecera, data-lp-offers). Va pintada (oculta) desde antes de empezar y sale sola al llegar su hora.
  // - data-lp-idle: lo que se ve cuando no hay ningún regalo (la nota de la barra fija, «Pago único» del cierre).
  // - La cuenta atrás (data-lp-cdwin) solo se ve en los últimos gift_cd_days días (0 = siempre) y cuenta hasta el final real.
  const cfg = (document.querySelector('[data-lp-offers]') || {}).dataset || {};
  const ms = (v) => Number(v || 0) * 1000;
  const offers = {
    1: { from: 0, to: ms(root.dataset.giftEnd), cta: root.dataset.giftCta || '' },
    2: { from: ms(cfg.o2From), to: ms(cfg.o2To), cta: cfg.o2Cta || '' },
  };
  const cdMs = Number(cfg.cdDays || 0) * 86400000;
  const WIN = '[data-lp-gift-show], [data-lp-win]';
  const wins = [...document.querySelectorAll(WIN)].map((el) => {
    const o = offers[el.hasAttribute('data-lp-win') ? el.dataset.lpWin : 1] || { from: 0, to: 0, cta: '' };
    const own = el.hasAttribute('data-lp-to');
    // Relojes, cuentas atrás y textos de este elemento (no los de otro regalo metido dentro).
    const mine = (sel) => [el, ...el.querySelectorAll(sel)].filter((x) => x.matches(sel) && x.closest(WIN) === el);
    return {
      el, cta: o.cta,
      from: own ? ms(el.dataset.lpFrom) : o.from,
      to: own ? ms(el.dataset.lpTo) : o.to,
      clocks: mine('[data-lp-clock]'), cds: mine('[data-lp-cd]'), cdwins: mine('[data-lp-cdwin]'),
    };
  });
  const hides = [...document.querySelectorAll('[data-lp-gift-hide]')];
  const idles = [...document.querySelectorAll('[data-lp-idle]')];
  document.querySelectorAll('[data-lp-gift-cta]').forEach((el) => { el.textContent = offers[1].cta; });
  wins.forEach((w) => w.el.querySelectorAll('[data-lp-cta-text]').forEach((el) => {
    if (el.closest(WIN) === w.el) el.textContent = w.cta;
  }));
  const pad = (n) => String(n).padStart(2, '0');
  const dayUnit = root.dataset.day || 'd';
  const tick = () => {
    const now = Date.now();
    let any = false;
    let later = false;
    wins.forEach((w) => {
      const on = w.to > 0 && now >= w.from && now < w.to;
      if (w.to > now) later = true;
      const left = w.to - now;
      const cd = on && (!cdMs || left <= cdMs);
      w.el.hidden = !on;
      if (on) any = true;
      w.cdwins.forEach((el) => { el.hidden = !cd; }); // si el propio elemento es la cuenta atrás, también
      if (!on) return;
      const s = Math.floor(left / 1000);
      const d = Math.floor(s / 86400);
      const h = Math.floor(s / 3600) % 24;
      const m = Math.floor(s / 60) % 60;
      const sec = s % 60;
      const txt = `${d > 0 ? `${d} ${dayUnit} ` : ''}${pad(h)}:${pad(m)}:${pad(sec)}`;
      w.clocks.forEach((el) => { el.textContent = txt; });
      w.cds.forEach((el) => {
        const set = (k, v) => { const b = el.querySelector(`[data-u="${k}"]`); if (b) b.textContent = pad(v); };
        set('d', d); set('h', h); set('m', m); set('s', sec);
      });
    });
    hides.forEach((el) => { el.hidden = offers[1].to > now; });
    idles.forEach((el) => { el.hidden = any; });
    return later;
  };
  if (tick()) {
    const t = setInterval(() => { if (!tick()) clearInterval(t); }, 1000);
    // En una pestaña de fondo el navegador frena los relojes: al volver a ella se pone al día en el acto.
    document.addEventListener('visibilitychange', () => { if (!document.hidden) tick(); });
    window.addEventListener('pageshow', tick);
  }

  // Vídeos: en silencio y solo mientras se ven, para no gastar datos.
  const reels = document.querySelectorAll('[data-lp-reel]');
  // Portadas diferidas (data-poster): se piden cuando la página ya ha cargado, para no competir con la imagen principal.
  const lazyPosters = [...reels].filter((v) => v.dataset.poster);
  if (lazyPosters.length) {
    const setPosters = () => lazyPosters.forEach((v) => { v.poster = v.dataset.poster; });
    if (document.readyState === 'complete') setPosters();
    else window.addEventListener('load', setPosters, { once: true });
  }
  const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reels.length && (still || !('IntersectionObserver' in window))) {
    reels.forEach((v) => { v.controls = true; v.preload = 'metadata'; });
  } else if (reels.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) target.play().catch(() => { target.controls = true; });
        else target.pause();
      });
    }, { threshold: 0.5 });
    reels.forEach((v) => { v.muted = true; io.observe(v); });
  }
})();
